import { useEffect, useState } from "react";
import { doc, updateDoc } from "firebase/firestore";
import { useDocument } from "react-firebase-hooks/firestore";
import { db } from "../firebase";
import { getDate } from "../timestamp";

export const useTimeMachine = () => {
  const [timeMachine, setTimeMachine] = useState();
  const [saving, setSaving] = useState(false);
  const docRef = doc(db, "timeMachine", "singleton");
  const [value, loading, error] = useDocument(docRef);
  useEffect(() => {
    if (value) {
      setTimeMachine(mapTimeMachine(value));
    }
  }, [value]);

  const setNow = (now) => {
    setSaving(true);
    return updateDoc(docRef, { now })
      .then(() => {
        setSaving(false);
      })
      .catch(() => {
        alert("Error saving time");
      });
  };

  return { timeMachine, loading, error, saving, setNow };
};

const mapTimeMachine = (snapshot) => {
  const data = snapshot.data();
  if (!snapshot.exists()) {
    console.warn(
      "Unable to initalize TimeMachine, check db for required record"
    );
    return null;
  }
  return {
    id: snapshot.id,
    ...data,
    now: getDate(data.now),
  };
};
